import React from 'react'
import { attributesToProps } from 'html-react-parser'
import { type Parser, domParser } from '.'

export const tableParser: Parser = (node, additionalMacros, additionalNodeParsers) => {
  if (node.type === 'tag' && node.name === 'table') {
    const props = attributesToProps(node.attribs)

    return (
      <div className="u-overflow-x-scroll u-overflow-sm-auto">
        <table {...props}>
          {domParser(node.children, additionalMacros, additionalNodeParsers)}
        </table>
      </div>
    )
  }
}
